<template>
	<validation-provider
			:name="'AdminSelectUsername-' + contentKey + '-' + inputItemKey"
			:rules="getValidationRules(contents[contentKey].inputItems[inputItemKey].rules)"
			v-slot="{ errors }">
		<v-autocomplete
				v-model="$store.state.admin.input[inputItemKey]"
				:items="arrayObject($_admnSlctUsrnm_stateAdminUsers())"
				item-text="username"
				item-value="username"
				placeholder="Select"
				@change="$_admnSlctUsrnm_setAdminState()"
				:error-messages="errors" />
	</validation-provider>
</template>

<script>
	export default {
		name: 'AdminSelectUsername',
		props: {
			contentKey: String,
			inputItemKey: String,
			contents: Object,
			inits: Object
		},
		computed: {
			$_admnSlctUsrnm_stateAdminUsers() {
				const self_ = this;
				return () => {
					const users_ = self_.getAdminState('users')
					return self_.sortObject(users_, 'username')
				}
			}
		},
		created() {
			const self_ = this;
			self_.$_admnSlctUsrnm_getUsers()
		},
		methods: {
			$_admnSlctUsrnm_getUsers() {
				const self_ = this;

				let users_ = self_.getAdminState('users')

				if(!self_.isEmpty(users_)) { return }

				Promise.resolve().then(() => {
					return self_.ipCliGetAppUsers()
				}).then(result => {
					const users_ = self_.objectArray(result, 'uid')
					self_.setAdminState('users', users_)					
				})
			},
			$_admnSlctUsrnm_setAdminState() {
				const self_ = this;

				let input_ = self_.getAdminState('input')
				const username_ = input_[self_.inputItemKey]

				input_.uid = self_.adminGetUser(username_, 'uid')
				input_.fullName = self_.adminGetUser(username_, 'full_name')
				// for update user
				if(self_.contentKey == 'updateUser') {
					input_.email = self_.adminGetUser(username_, 'email')
					input_.phone = self_.adminGetUser(username_, 'phone')
				}
				// for change user group
				if(self_.contentKey == 'changeUserGroup') {
					input_.userGroupCode = self_.adminGetUser(username_, 'user_group_code')
					input_.userGroupName = self_.adminGetUser(username_, 'user_group_name')
				}
				// for change security group
				if(self_.contentKey == 'changeSecurityGroup') {
					input_.securityGroupCode = self_.adminGetUser(username_, 'security_group_code')
					input_.securityGroupName = self_.adminGetUser(username_, 'security_group_name')
				}
				// for change user status
				if(self_.contentKey == 'changeUserStatus') {
					input_.blocked = self_.adminGetUser(username_, 'blocked')
					input_.disabled = self_.adminGetUser(username_, 'disabled')
				}
				// for send email notification
				if(self_.contentKey == 'sendEmailNotification') {
					input_.email = self_.adminGetUser(username_, 'email')
				}
				// for send sms notification
				if(self_.contentKey == 'sendSmsNotification') {
					input_.phone = self_.adminGetUser(username_, 'phone')
				}
				self_.setAdminState('input', input_)
			}
		}
	}
</script>

<style scoped>
</style>
